import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import type { RootState } from "../app/store";

const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const { role } = useSelector((state: RootState) => state.auth);

  if (role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
